import window from './window_wrapper';

export const GRANTED = 'granted';
export const DENIED = 'denied';

export interface IPrivacyConsentSettings {
  adData: boolean
  adStorage: boolean
  adPersonalization: boolean
  analyticsStorage: boolean
}

export function updateGoogleConsent(privacyConsentSettings: IPrivacyConsentSettings) {
  const {
    adData,
    adStorage,
    adPersonalization,
    analyticsStorage,
  } = privacyConsentSettings;

  if (window.gtag !== undefined) {
    window.gtag('consent', 'update', {
      'ad_user_data': adData ? GRANTED : DENIED,
      'ad_storage': adStorage ? GRANTED : DENIED,
      'ad_personalization': adPersonalization ? GRANTED : DENIED,
      'analytics_storage': analyticsStorage ? GRANTED : DENIED,
    });
  }
}
